import Shell from '../components/Shell';
import type { Branding, DeviceLocationMode } from '../types';

interface StartPageProps {
  branding: Branding;
  busy: boolean;
  error: string | null;
  retryInfo: { attemptsRemaining: number } | null;
  deviceLocation: DeviceLocationMode;
  onStart: () => void;
}

// The web Face Liveness SDK cannot auto-adjust screen brightness the way the
// mobile SDKs can (AWS docs), so we ask for it explicitly — it measurably
// improves the pass rate.
export default function StartPage({ branding, busy, error, retryInfo, deviceLocation, onStart }: StartPageProps) {
  return (
    <Shell branding={branding}>
      <h1>Antes de comenzar</h1>

      {retryInfo && (
        // Never why the capture must be repeated (reasonCode is always CAPTURE_RETRY, D4).
        <div className="retry-banner" role="status">
          <p>No pudimos completar la captura. Intentemos de nuevo.</p>
          {retryInfo.attemptsRemaining > 0 ? (
            <p>
              Te {retryInfo.attemptsRemaining === 1 ? 'queda 1 intento' : `quedan ${retryInfo.attemptsRemaining} intentos`}.
            </p>
          ) : (
            <p>No quedan más intentos disponibles.</p>
          )}
        </div>
      )}

      <ul className="tips-list">
        <li>Sube el brillo de tu pantalla al máximo.</li>
        <li>Busca un lugar con buena iluminación, de frente a una fuente de luz.</li>
        <li>Quítate lentes oscuros, gorras o cualquier cosa que cubra tu rostro.</li>
        <li>Sostén el dispositivo a la altura de los ojos y mantente centrado.</li>
        {deviceLocation === 'OPTIONAL' && <li>Te pediremos permiso para usar tu ubicación.</li>}
        {deviceLocation === 'REQUIRED' && (
          <li>Te pediremos permiso para usar tu ubicación; es necesaria para continuar.</li>
        )}
      </ul>

      {error && <p className="error-text">{error}</p>}

      <button className="btn-primary" disabled={busy} onClick={onStart}>
        {busy ? 'Iniciando…' : 'Comenzar verificación'}
      </button>
    </Shell>
  );
}
